export const columnsMenuStyle = {
	wrapper: {
		background: 'var(--background-grey-op-50-1)',
		borderRadius: '8px',
	},

	option: {
		width: '200px',
		cursor: 'pointer',

		'&:last-child': {
			color: 'var(--error-500)',
		},
	},

	buttonWrap: {
		display: 'flex',
		width: '100%',
		maxWidth: '127px',
		borderRadius: '8px',
		padding: '10px 16px',
		height: '44px',
		background: 'var(--background-grey-op-50-1)',
	},

	button: {
		display: 'flex',
		fontWeight: 400,
		width: '100%',
		padding: '10px 16px',

		svg: {
			fill: 'var(--neutral-900)',
		},

		'&.MuiButton-root': {
			color: 'var(--neutral-900)',
		},
	},

	activeButton: {
		fontWeight: 400,
		padding: '10px 16px',

		svg: {
			fill: 'var(--primary-500)',
		},
	},

	disabledButton: {
		fontWeight: 400,
		padding: '10px 16px',
		

		svg: {
			fill: 'var(--neutral-300)',
		},

		'&.MuiButton-root': {
			color: 'var(--neutral-300)',
		},
	},
};
